import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  fetchUserInfo,
  fetchSubStats,
  setFilter,
  resetFilter,
} from '../../../actions';
import { SubID } from '../../../components/Reports';

const mapStateToProps = (state) => ({
  user: state.user.payload,
  pageLoading: state.user.pageLoading,
  loading: state.reports.loading,
  subStats: state.reports.subStats,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUserInfo,
      fetchSubStats,
      setFilter,
      resetFilter,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SubID);

